<template lang="pug">
  a.feature-categories-tile(:href="`${category.url}`" data-aos="flip-up" :data-aos-delay="index * 100")
    .feature-categories-tile__background-image(v-if="category.image" v-lazy:background-image="category.image" :alt="category.imageAlt")
    slot(name="svg" v-else)
    .feature-categories-tile__overlay
    .feature-categories-tile__text-wrapper
      h2.feature-categories-tile__title
        span.feature-categories-tile__title-span {{ category.title }}
          span.feature-categories-tile__icon
            icon(name='chevron-right' size='14px')
      p.feature-categories-tile__description(ref="description") {{ category.description }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import { getSizedImageUrl } from 'scripts/filters/images.js';

  import AOS from 'aos';
  import 'aos/dist/aos.css'
  import $clamp from 'clamp-js';

  export default {
    name: 'FeaturedCategoriesTile',
    components: { Icon },
    props: {
      category: Object,
      index: Number
    },
    data() {
      return {
        imageSize: '500x',
      }
    },
    computed: {
      imageSrc () {
        let imageSrc = this.category.image;
        return imageSrc ? getSizedImageUrl(imageSrc, this.imageSize) : null;
      },
      imageAlt () {
        let image = this.category.image;
        return image ? image.alt : null;
      }
    },
    mounted() {
      $clamp(this.$refs.description, {clamp: 3})
    },
    created () {
      AOS.init();
    },
  };
</script>

<style scoped lang="scss">
</style>
